import BatteryGradesTable from "./BatteryGradesTable";

export default BatteryGradesTable;
